const state = {}

const mutations = {
  setUserValue(state, payload) {
    Vue.$nestedSet(state, payload.path, payload.value);
  },
}

const actions = {}

const getters = {
  getUserValueByPath: state => path => Vue.$lodash.get(state, path)
}

export default {
  ['user']:{ state, mutations, actions, getters }
}
